/* eslint-disable import/no-unresolved */
import React from "react";
import ShopOrdersList from "components/pages/user/orders/ShopOrderList";
import WholesaleHeaderNav from "components/elements/main/WholesaleHeaderNav";

const WholesaleShopOrderList = (props) => {

    return (
        <div>
            <WholesaleHeaderNav {...props} />
            <ShopOrdersList {...props} wholesale={true} />
        </div>
    );
};

export default (WholesaleShopOrderList);
